import React, { useState, useContext } from 'react';
import cssClass from './CreateRoadmapScreen.module.css';
import back from '../assets/back.svg';
import Header from './Header';
import Footer from './Footer';
import { UserContext } from '../context/UserContext';
import { useNavigate } from 'react-router-dom';

/**
 * CreateRoadmapScreen Component
 *
 * This component allows to create a new roadmap by providing details like title, description, and difficulty level.
 * It consists of a multi-step UI(currently single step), a form to capture roadmap details, and a submission button.
 *
 * @component
 * @returns {JSX.Element} The rendered CreateRoadmapScreen component.
 */
const CreateRoadmapScreen = () => {
  // Hook to handle navigation between routes
  const navigate = useNavigate();
  // Get user details from context
  const { userDetails } = useContext(UserContext);
  // State to manage form data
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    level: '',
    price: 0,
  });

  /**
   * Handles changes in input fields and updates the form state.
   * @param {Object} e - The event object from input change.
   */
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Check if all form fields are filled to enable the "Next" button
  const isFormComplete =
    formData.title &&
    formData.description &&
    formData.level &&
    formData.price &&
    Number(formData.price) !== 0;

  /**
   * Submits the form data to the backend to create a new roadmap.
   * On success, navigates to the roadmap drawing screen.
   * @param {Object} event - The event object from form submission.
   */
  const createNewRoadmap = async (event) => {
    event.preventDefault();
    try {
      const data = {
        e: userDetails?.email,
        r_title: formData.title,
        r_desc: formData.description,
        r_level: formData.level,
        r_price: Number(formData.price).toFixed(1),
      };
      const response = await fetch(
        `${process.env.REACT_APP_SERVER_URL}/r/create-roadmap`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          // credentials: 'include',
          body: JSON.stringify(data),
        },
      );
      const responseData = await response.json();
      // If successfully created, navigate to roadmap drawing page
      if (response.status === 201) {
        const roadmapId = responseData?.id;
        navigate('/', { replace: true });
        navigate(`/draw-roadmap/${roadmapId}`);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className={cssClass['wrapper']}>
      <div className={cssClass['container']}>
        {/* Header Component */}
        <Header />

        {/* Back Button to go to the previous screen */}
        <div className={cssClass['backButton']} onClick={() => navigate('/')}>
          <img src={back} alt="back-button" className={cssClass.back} />
          {/* Create new team */}
        </div>

        {/* Multi-step Progress UI */}
        {/* <div className={cssClass['roadmapContainer']}>
          <div className={cssClass['roadmap-item']}>
            <div className={cssClass['step-container']}>
              <div className={cssClass['circle1']}>
                <div className={cssClass['dot']}></div>
              </div>
            </div>

            <hr className={cssClass['hor1']} />

            <div className={cssClass['step-container']}>
              <div className={cssClass['circle-middle']}></div>
            </div>

            <hr className={cssClass['hor2']} />

            <div className={cssClass['step-container']}>
              <div className={cssClass['circle2']}></div>
            </div>
          </div>
        </div> */}

        {/* Step Labels */}
        {/* <div className={cssClass['roadmapContainer1']}>
          <div className={cssClass['roadmap-item1']}>
            <span className={cssClass['step-label2']}>Roadmap Details</span>
          </div>
          <div className={cssClass['roadmap-item1']}>
            <span className={cssClass['step-label1']}>Create Roadmap</span>
          </div>
          <div className={cssClass['roadmap-item1']}>
            <span className={cssClass['step-label1']}>Save Roadmap</span>
          </div>
        </div> */}

        {/* Form Container */}
        <div className={cssClass['full-conatiner']}>
          <div className={cssClass['form-container']}>
            <form>
              {/* Roadmap Name Field */}
              <div className={cssClass['form-group']}>
                <label className={cssClass['name']}>Roadmap Name</label>
                <input
                  type="text"
                  name="title"
                  className={cssClass.input}
                  value={formData.title}
                  onChange={handleChange}
                />
              </div>

              {/* Roadmap Description Field */}
              <div className={cssClass['form-group']}>
                <label className={cssClass['name']}>Roadmap Description</label>
                <textarea
                  name="description"
                  className={cssClass['input1']}
                  value={formData.description}
                  onChange={handleChange}
                ></textarea>
              </div>

              {/* Level Selection Dropdown */}
              <div className={cssClass['form-group']}>
                <label className={cssClass['name']}>Level</label>
                <select
                  name="level"
                  className={cssClass['input2']}
                  value={formData.level}
                  onChange={handleChange}
                >
                  <option value="">Select Level</option>
                  <option value="beginner">Beginner</option>
                  <option value="intermediate">Intermediate</option>
                  <option value="advanced">Advanced</option>
                </select>
              </div>
              <div className={cssClass['form-group1']}>
                <label className={cssClass['name']}>Roadmap Price</label>
                <input
                  type="number"
                  name="price"
                  className={cssClass.input}
                  value={formData.price}
                  onChange={handleChange}
                  inputMode="numeric"
                />
              </div>
            </form>
          </div>
        </div>

        {/* Submission Button */}
        <div className={cssClass['button-container']}>
          <button
            type="submit"
            className={`${cssClass.button} ${
              isFormComplete ? cssClass.active : ''
            }`}
            disabled={!isFormComplete}
            onClick={createNewRoadmap}
          >
            Next
          </button>
        </div>

        {/* Footer Component */}
        <Footer />
      </div>
    </div>
  );
};

export default CreateRoadmapScreen;
